import { getApi } from './common/apis';

export default class IndustryService {
    async getIndustries() {
        const data = await getApi('/v1/industries');
        return data;
    }
}
